import { controllerFactory } from "@utils/createController";

export default class extends controllerFactory()({
  targets: {
    emptyRoot: null,
    input: HTMLInputElement,
    optionRoot: null,
    searchString: null,
  },
}) {
  private labels: { el: HTMLElement; searchString: string }[];

  private handleNewQuery(query: string) {
    let foundSomething = false;

    for (const { el, searchString } of this.labels) {
      const contains = searchString.includes(query.trim().toLowerCase());

      if (!foundSomething && contains) foundSomething = true;

      if (contains) {
        el.classList.remove("hidden");
      } else {
        el.classList.add("hidden");
      }
    }

    if (foundSomething) {
      this.emptyRootTarget.classList.add("hidden");
    } else {
      this.emptyRootTarget.classList.remove("hidden");
    }
  }

  connect() {
    this.labels = this.searchStringTargets.map((el, i) => {
      return {
        el: this.hasOptionRootTarget
          ? this.optionRootTargets[i]
          : (el.parentElement as HTMLElement),
        searchString: (el.innerHTML ?? "").trim().toLowerCase(),
      };
    });
    this.reset();
  }

  handleInput() {
    if (this.hasSearchStringTarget) this.handleNewQuery(this.inputTarget.value);
  }

  reset() {
    this.handleNewQuery("");
    if (this.hasInputTarget) this.inputTarget.value = "";
  }
}
